import { render, staticRenderFns } from "./ModalGestores.vue?vue&type=template&id=0aaaff37"
import script from "./ModalGestores.vue?vue&type=script&lang=ts"
export * from "./ModalGestores.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports